import { Injectable } from '@angular/core';

@Injectable()
export class FnGridLookupService {
	private lookupMetaData:any = {}; // {lookupKey:[{primaryKey:primaryKey,data:''}]}

	// we merged the lookumetadata.
	setLookupData(lookupData: Object|any) {
		const lookupKeys = Object.keys(lookupData);
		for (const key of lookupKeys) {
			this.lookupMetaData[key] = lookupData[key];
		}
	}

	setLookArrayForKey(lookupArray: Array<any>, lookupKey: string) {
		this.lookupMetaData[lookupKey] = lookupArray;
	}

	getLookArrayForKey(lookupKey: string) {
		return this.lookupMetaData[lookupKey];
	}
}
